import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

const URL = 'payment-options-proxy?endpoint=paymentdashboard';

export const getPropertyKeys = createAsyncThunk(
  'propertyKeys',
  async (_, { getState }) => {
    const statePropertyKeys =
      getState().paymentOptions.propertyKeys.propertyKeyList;

    if (statePropertyKeys.length) return { properties: statePropertyKeys };

    const url = `${URL}/propertykeys`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    response.data.properties.sort((a, b) => a.id - b.id);

    return response.data;
  },
);

export const getPropertyKeyDetails = createAsyncThunk(
  'propertyKeys/{propertyKeyId}',
  async (propertyKeyId) => {
    const url = `${URL}/propertykeys/${propertyKeyId}`;
    const response = await apiConfig.get(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const updatePropertyKey = createAsyncThunk(
  'propertyKeys/{propertyKeyId}/update',
  async (payload) => {
    const url = `${URL}/propertykeys/${payload.id}`;
    const response = await apiConfig.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const addNewPropertyKey = createAsyncThunk(
  'propertyKeys/{propertyKeyId}/addNew',
  async (payload) => {
    const url = `${URL}/propertykeys`;
    const response = await apiConfig.post(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const paymentOptionsPropertyKeysSlice = createSlice({
  name: 'paymentOptionsPropertyKeys',
  initialState: {
    propertyKeyList: [],
    selectedPropertyKey: {},
  },
  reducers: {
    resetPropertyKeys(state) {
      state.propertyKeyList = [];
    },
    resetSelectedPropertyKey(state) {
      state.selectedPropertyKey = {};
    },
  },
  extraReducers: {
    [getPropertyKeys.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.properties) {
        state.propertyKeyList = [];
        return;
      }

      state.propertyKeyList = action.payload.properties;
    },
    [getPropertyKeyDetails.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.id) {
        state.selectedPropertyKey = {};
        return;
      }

      state.selectedPropertyKey = action.payload;
    },
  },
});

export const selectPropertyKeys = (state) =>
  state.paymentOptions.propertyKeys.propertyKeyList;

export const selectSelectedPropertyKey = (state) =>
  state.paymentOptions.propertyKeys.selectedPropertyKey;

export const paymentOptionsPropertyKeysActions =
  paymentOptionsPropertyKeysSlice.actions;

export default paymentOptionsPropertyKeysSlice.reducer;
